function verifyBack(_this) {
    var $that = $(_this).parents('div.modal')

    $that.find('#verification-result-div').hide();
    $that.find('.verification-steps').find('.active').removeClass('active')
    $that.find('.verification-steps .step1').closest('div').addClass('active')
    $that.find('#verification-email-form-group').removeClass('has-success')
    // $that.find('#verification-conditions').props('checked', false)
    // $that.find('#verification-newsletter').props('checked', false)

    $that.find('#verification-form-div').show();
}
